export const calculatePixOutFee = (fees, amountBRL) => {
  if (!fees) return 0;
  const fixedFeeCent = fees.pixOutFixedFee ?? 0; // already in centavos
  const variableFee  = fees.pixOutVariableFee ?? 0; // e.g. 0.0075
  const amountCent   = Math.floor(parseFloat(amountBRL || 0) * 100);
  const feeCent      = fixedFeeCent + Math.floor(amountCent * variableFee);
  return feeCent / 100; // back to BRL
};

export const calculateInputForPixOut = (fees, outputBRL) => {
  if (!fees) return outputBRL;
  const fixedFeeCent = fees.pixOutFixedFee ?? 0;
  const variableFee  = fees.pixOutVariableFee ?? 0;
  const outCent      = Math.floor(parseFloat(outputBRL || 0) * 100);

  // First estimate (ceil ensures input ≥ required)
  let inCent = Math.ceil((outCent + fixedFeeCent) / (1 - variableFee));
  let feeCent = fixedFeeCent + Math.floor(inCent * variableFee);

  // Adjust because fee uses floor()
  while (inCent - feeCent < outCent) {
    inCent += 1;
    feeCent = fixedFeeCent + Math.floor(inCent * variableFee);
  }

  return inCent / 100; // return in BRL
}; 